import { Link } from 'react-router'

import './PrivacyPage.css'

/**
 * Politique de confidentialite — page publique requise pour la soumission
 * Pinterest API (et OAuth Etsy / TikTok plus tard). Contenu statique en FR,
 * aligne sur la realite du backend (tokens OAuth chiffres Fernet, pas de
 * donnees acheteur, hebergement UE, droits RGPD via interface).
 */
export default function PrivacyPage() {
  return (
    <main className="privacy-page">
      <header className="privacy-page-header">
        <p className="ui-eyebrow privacy-page-eyebrow">SgraphiCCreations</p>
        <h1 className="ui-h2 privacy-page-title">Politique de confidentialite</h1>
        <p className="privacy-page-meta">Derniere mise a jour : 10 mai 2026</p>
      </header>

      <article className="privacy-page-content">
        <section className="privacy-page-section">
          <h2 className="ui-h3">1. Nature de l&rsquo;outil</h2>
          <p>
            Sgraphic.art est un outil interne d&rsquo;atelier a usage prive, exploite par
            SgraphiCCreations, artiste independante. Il permet a l&rsquo;artiste de gerer la
            diffusion de ses ouvres (peintures, illustrations originales) sur ses propres comptes
            professionnels Etsy, Pinterest Business, Instagram et TikTok. L&rsquo;outil est
            mono-utilisateur et mono-compte par plateforme. Il ne propose pas d&rsquo;inscription
            publique, ne commercialise aucun service a des utilisateurs externes, et ne collecte
            aucune donnee aupres de visiteurs tiers.
          </p>
        </section>

        <section className="privacy-page-section">
          <h2 className="ui-h3">2. Donnees collectees</h2>
          <p>L&rsquo;application stocke uniquement :</p>
          <ul>
            <li>
              <strong>Identifiants de connexion de l&rsquo;artiste</strong> : e-mail et mot de passe
              (hache par argon2id, jamais en clair).
            </li>
            <li>
              <strong>Jetons d&rsquo;acces OAuth</strong> delivres par les plateformes (Etsy,
              Pinterest&hellip;) lorsque l&rsquo;artiste autorise la connexion. Ces jetons sont
              chiffres en base via Fernet (AES-128 CBC + HMAC-SHA256).
            </li>
            <li>
              <strong>Metadonnees des ouvres</strong> creees par l&rsquo;artiste : titre,
              descriptions bilingues, tags, prix, images des ouvres.
            </li>
            <li>
              <strong>Metriques publiques agregees</strong> retournees par les plateformes (vues,
              favoris, ventes de l&rsquo;artiste) a des fins de pilotage interne.
            </li>
          </ul>
          <p>
            Aucune donnee d&rsquo;acheteur, de visiteur tiers, de contact externe ou de profil de
            tiers n&rsquo;est collectee ni stockee.
          </p>
        </section>

        <section className="privacy-page-section">
          <h2 className="ui-h3">3. Utilisation des donnees Pinterest</h2>
          <p>
            Lorsque l&rsquo;artiste connecte son compte Pinterest Business via OAuth,
            l&rsquo;application est autorisee a :
          </p>
          <ul>
            <li>
              creer une Epingle par ouvre de son catalogue, avec lien vers la fiche Etsy
              correspondante ;
            </li>
            <li>lire les statistiques publiques de ses propres Epingles.</li>
          </ul>
          <p>
            Volume estime : 20 a 30 Epingles par mois. L&rsquo;application n&rsquo;epingle jamais de
            contenu de tiers et n&rsquo;agit que sur le compte connecte par l&rsquo;artiste.
          </p>
        </section>

        <section className="privacy-page-section">
          <h2 className="ui-h3">4. Conservation et revocation</h2>
          <p>
            Les jetons OAuth sont conserves tant que la connexion plateforme reste active.
            L&rsquo;artiste peut revoquer une connexion a tout moment depuis sa page Reglages
            &mdash; la copie chiffree est alors supprimee de la base.
          </p>
        </section>

        <section className="privacy-page-section">
          <h2 className="ui-h3">5. Hebergement</h2>
          <p>
            Les donnees sont hebergees sur un serveur dedie situe en Union europeenne, accessible
            uniquement par l&rsquo;artiste via authentification.
          </p>
        </section>

        <section className="privacy-page-section">
          <h2 className="ui-h3">6. Droits (RGPD)</h2>
          <p>
            L&rsquo;artiste exerce ses droits d&rsquo;acces, de rectification et de suppression
            directement depuis l&rsquo;interface (edition d&rsquo;ouvre, deconnexion d&rsquo;une
            plateforme, suppression de compte sur demande).
          </p>
        </section>

        <section className="privacy-page-section">
          <h2 className="ui-h3">7. Contact</h2>
          <p>
            Pour toute question :{' '}
            <a href="mailto:contact@sgraphic.art" className="privacy-page-link">
              contact@sgraphic.art
            </a>
          </p>
        </section>
      </article>

      <footer className="privacy-page-footer">
        <Link to="/" className="privacy-page-back">
          &larr; Retour a l&rsquo;accueil
        </Link>
      </footer>
    </main>
  )
}
